import { render, staticRenderFns } from "./BookingsFilled.vue?vue&type=template&id=183884c5"
import script from "./BookingsFilled.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingsFilled.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports